import AutocompleteStore from 'core/stores/AutocompleteStore.js';

export const LOCALITY_URL =
    '/api/professionals/v1/search/hospitals-localities/?show=site';

/**
 * The suburb / hospital / postcode field on the health fund widget.
 *
 * Ported from the `<auto-complete params="name: 'search-locality' …">` element
 * in insurer_widget.html. Two details carried over: the suggestion label is
 * built from name, state and post code, and the icon distinguishes a hospital
 * from a locality. The selected item's `type` also has to reach the form,
 * because the directory index reads `locality_type` alongside `locality_id`.
 */
export default class LocalityAutocompleteStore extends AutocompleteStore {
    constructor(parentStore) {
        super(LOCALITY_URL, parentStore);
    }

    transformSuggestions(suggestions) {
        return suggestions.map((result) => ({
            ...result,
            icon:
                result.type === 'hospital'
                    ? 'fa fa-fw fa-plus-square text-blue'
                    : 'fa fa-fw fa-map-marker text-orange',
            name: [result.name, result.state, result.postCode]
                .filter(Boolean)
                .join(' '),
        }));
    }
}
